export const VUEX_ALERT_DIALOG_SHOW = 'VUEX_ALERT_DIALOG_SHOW'
export const VUEX_ALERT_DIALOG_HIDE = 'VUEX_ALERT_DIALOG_HIDE'
export const VUEX_ALERT_DIALOG_USER_DISMISS = 'VUEX_ALERT_DIALOG_USER_DISMISS'
